<template>
    <div class="common_container">
        <el-form ref="form" :model="form" label-width="90px" class="event-form" :rules="rules">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="名称" prop="title">
                        <el-input type="text" placeholder="" v-model="form.title" class="form-input"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" ></el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="两头班" prop="twoEnds">
                        <el-checkbox v-model="form.twoEnds" @change="selectTwo"></el-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :span="12" ></el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item label="班次时间段1" prop="startTime1">
                        <el-time-select
                            placeholder="起始时间"
                            v-model="form.startTime1"
                            :picker-options="{
                                start: '00:00',
                                step: '00:30',
                                end: '24:00',
                                maxTime: form.endTime1
                            }"
                            @change="showTime1"
                        >
                        </el-time-select>
                        <span> - </span>
                        <el-time-select
                            placeholder="结束时间"
                            v-model="form.endTime1"
                            :picker-options="{
                                start: '00:00',
                                step: '00:30',
                                end: '24:00',
                                minTime: form.startTime1
                            }"
                            @change="showTime2"
                        >
                        </el-time-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item label="班次时间段2" >
                        <el-time-select
                            placeholder="起始时间"
                            :disabled='hasTwoTime'
                            v-model="form.startTime2"
                            :picker-options="{
                                start: '00:00',
                                step: '00:30',
                                end: '24:00',
                                minTime: form.endTime1,
                                maxTime: form.endTime2
                            }">
                        </el-time-select>
                        <span> - </span>
                        <el-time-select
                            placeholder="结束时间"
                            :disabled='hasTwoTime'
                            v-model="form.endTime2"
                            :picker-options="{
                                start: '00:00',
                                step: '00:30',
                                end: '24:00',
                                minTime: form.startTime2
                            }">
                        </el-time-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="总时长">
                        <el-input type="text" placeholder="" v-model="totalTime" disabled class="form-input"></el-input>
                        <span class="ml10">小时</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-row>
                <el-col :span="12">
                    <el-form-item label="背景颜色" prop="background">
                        <el-color-picker v-model="form.background" @change="selectColor"></el-color-picker>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="工作类型" prop="workType">
                        <el-select v-model="form.workType" placeholder="请选择" class="form-input">
                            <el-option v-for="item in scheduling_work_type" :key="item.id" :label="item.cname"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" @click="submit" :disabled="isSubmit">提交</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

    import services from './workforce.service.js';
    import {getRules} from "./workforce.rules";
    const rules=getRules()
    export default {
        props:{
            type:{
                type:String,
                default:"add"
            },
            message:Number,
            callback:Function
        },
        data() {
            return {
                formName:"form",
                rules:rules,
                form:{
                    title:'',
                    twoEnds:false,
                    startTime1:'',
                    endTime1:'',
                    startTime2:'',
                    endTime2:'',
                    totalTime:this.totalTime,
                    background:'#409EFF',
                    workType:'',
                },
                typeList:[//工作类型
                    {id:1,cname:'123'},
                    {id:2,cname:'456'},
                    {id:3,cname:'789'}
                ],
                hasTwoTime:true,//是否可以选择班次时间段2
                isSubmit:false
            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            scheduling_work_type(){//类型名称
                return this.dictionary.scheduling_work_type;
            },
            totalTime:{
                get(){
                    if (this.hasTwoTime){
                        if (this.form.startTime1&&this.form.endTime1) {
                            return this.computedTime(this.form.startTime1, this.form.endTime1)
                        }
                    } else{
                        if (this.form.startTime1&&this.form.endTime1&&this.form.startTime2&&this.form.endTime2) {
                            return this.computedTime(this.form.startTime1, this.form.endTime1,this.form.startTime2,this.form.endTime2)

                        }else{
                            return null
                        }
                    }
                },
                set(newValue){

                }


            }
        },
        mounted(){
            if(this.type == 'edit'){
                this.$modal.title = "修改信息";
                this.getDetail();
            }
        },
        methods:{
            showTime1(){
                // console.log(this.form.startTime1);
            },
            showTime2(){
                // console.log(this.form.endTime1);
                // console.log(this.computedTime(this.form.startTime1, this.form.endTime1));
            },
            computedTime(t1,t2,t3,t4){
                //t1  '02:30'  t2  '03:00'
                let startH1=t1&&t1.slice(0,2) //'02'
                let endH1 = t2&&t2.slice(0,2) //'03'
                let startM1=t1&&t1.slice(3)
                let endM1= t2&&t2.slice(3)
                let startH2=t3&&t3.slice(0,2) //'02'
                let endH2 = t4&&t4.slice(0,2) //'03'
                let startM2=t3&&t3.slice(3)
                let endM2= t4&&t4.slice(3)
                let H1=endH1-startH1
                let M1=endM1-startM1
                let H2=endH2-startH2
                let M2=endM2-startM2
                if (this.hasTwoTime){
                    // console.log(H1);
                    // console.log(M1);
                    if (M1<0){
                        H1-=1
                        M1=5
                        return H1+'.'+M1
                    } else if (M1<30){
                        return H1
                    } else if (M1==30){
                        M1=5
                        return H1+'.'+M1
                    }

                } else{
                    let T1
                    let T2
                    if (M1<0){
                        H1-=1
                        M1=5
                        T1=Number(H1+'.'+M1)
                    } else if (M1<30) {
                        T1= Number(H1)
                    }else if (M1==30){
                        M1=5
                        T1=Number(H1+'.'+M1)
                    }
                    if (M2<0){
                        // console.log(T1);
                        H2-=1
                        M2=5
                       T2=Number(H2+'.'+M2)
                        return T1+T2
                    } else if (M2<30){
                        // console.log(T1);
                        T2=Number(H2)
                        return T1+T2
                    } else if (M2==30){
                        // console.log(T1);
                        M2=5
                        T2=Number(H2+'.'+M2)
                        return T1+T2
                    }


                }


            },
            getDetail(){//获取班次详情
                services.detailScheduling({id:this.message}).then(res => {
                    res.workType = ''+res.workType;
                    this.form = res;
                    this.totalTime=this.form.totalTime
                    this.hasTwoTime = res.twoEnds?false:true;
                    this.form.twoEnds = res.twoEnds?true:false;
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            selectTwo(data){//选择是否是两头班
                // console.log(data);
                if(data){
                    this.hasTwoTime = false;
                }else{
                    this.hasTwoTime = true;
                }
            },
            selectColor(data){//选择背景颜色
                if(!data){
                    this.form.background = '#409EFF';
                }
            },
            submit(){//提交信息
                this.isSubmit=true
                let formName = this.formName;
                this.$refs[formName].validate((valid)=>{
                    if (valid){
                        this.form.twoEnds = Number(this.form.twoEnds?'1':'0');//判断是否是两头班，是传1，否传0
                        this.form.totalTime=this.totalTime
                        if(this.type == 'edit'){
                            this.form.id = this.message;
                            services.updateScheduling(this.form).then(res => {
                                this.$message.success("成功修改排班信息");
                                this.close(true);
                            }).catch(err => {
                                this.isSubmit=false
                                this.$message.error(err.message);
                            })
                        }else{
                            services.addScheduling(this.form).then(res => {
                                this.$message.success("成功添加排班");
                                this.close(true);
                            }).catch(err => {
                                this.isSubmit=false
                                this.$message.error(err.message);
                            })
                        }
                    }else{
                        this.isSubmit=false
                        this.$message.error('✳为必填项，请全部填写')
                    }
                    return valid;
                })

            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
